import { FileType } from 'types';
import { Icon } from 'components/icon';
import { EllipsisText } from 'components/ellipsis-text';
import { Image, isBrowserImage } from 'components/image';

import * as Styles from './styles';
import { DropZoneContentProps } from './types';

export const DropZoneContent = ({
  previewSrc,
  file: dropFile,
}: DropZoneContentProps) => {
  const { src, file } = dropFile || {};
  const { name, type } = file || {};
  // A picked photo previews only when every browser can draw it; a HEIC/HEIF
  // (iPhone original, also from Windows Chrome without a MIME type, D6)
  // shows as a file, like a PDF, never a broken image (the same rule as
  // components/image, FIX-OPS-UPLOAD-TYPES).
  const isImage =
    Boolean(type?.includes(FileType.Image)) &&
    (typeof src !== 'string' ||
      !src.startsWith('data:') ||
      isBrowserImage(src));
  const imageSrc = previewSrc === undefined ? src : previewSrc || undefined;

  const title = src ? (
    (name ?? type ?? '')
  ) : (
    <>
      Drag your file here, or <span>browse</span>
    </>
  );

  return (
    <Styles.DropContainer withoutBg={isImage}>
      {isImage && <Image clickable alt={src} src={imageSrc} />}

      <Styles.Wrapper>
        {src && file && !isImage ? <Icon.FileFilled /> : <Icon.Image />}
        <h4>
          <EllipsisText>{title}</EllipsisText>
        </h4>
      </Styles.Wrapper>
    </Styles.DropContainer>
  );
};
